import styled from "styled-components";
import { palette } from "styled-theme";
import { transition, borderRadius } from "../../settings/style-util";
import WithDirection from "../../settings/withDirection";

const SidebarHorizontalWrapper = styled.div`
  position: fixed;
  width: 100%;
  height: auto;
  top: 60px;
  z-index: 999;
  border-top: 1px solid #f1f1f1;
    box-shadow: 2px 2px 15px 1px #d7d7d7;
    background: #fff;

  
    .dpoimagesmenu{
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 5px
    }
    
  .sidebar-menu-icons {
    margin-left: ${(props) => (props["data-rtl"] === "rtl" ? "5px" : "0")};
  }
  .isomorphicSidebarHorizontal.ant-layout-sider
    .isoDashboardMenu
    .ant-menu-item-selected {
    border-left: ${(props) =>
    props["data-rtl"] === "rtl"
      ? "0px solid transparent;"
      : "0px solid #E8572D;"};
    border-right: ${(props) =>
    props["data-rtl"] === "rtl"
      ? "0px solid #E8572D;"
      : "0px solid transparent;"};
    background-color: #ffffff !important;
  }
  .isomorphicSidebarHorizontal {
    top: 0px;
    z-index: 1000;
    background: #ffffff;
    width: 220px;
    flex: 0 0 220px;
    z-index: 1;

    @media only screen and (max-width: 767px) {
      width: 240px !important;
      flex: 0 0 240px !important;
      top: 60px;
    }

    &.ant-layout-sider-collapsed {
      @media only screen and (max-width: 767px) {
        width: 0;
        min-width: 0 !important;
        max-width: 0 !important;
        flex: 0 0 0 !important;
      }
    }

    .isoLogoWrapper {
      display: none;
      height: 70px;
      background: rgba(0, 0, 0, 0.3);
      margin: 0;
      padding: 0 10px;
      text-align: center;
      overflow: hidden;
      ${borderRadius()};

      h3 {
        a {
          font-size: 21px;
          font-weight: 300;
          line-height: 70px;
          letter-spacing: 3px;
          text-transform: uppercase;
          color: ${palette("grayscale", 6)};
          display: block;
          text-decoration: none;
        }
      }
    }

    &.ant-layout-sider-collapsed {
      .isoLogoWrapper {
        padding: 0;

        h3 {
          a {
            font-size: 27px;
            font-weight: 500;
            letter-spacing: 0;
          }
        }
      }
    }

    .isoDashboardMenu {
      padding-top: 0px;
      // padding-bottom: 15px;
      background: transparent;
      display: flex;
    float: left;

      a {
        text-decoration: none;
        font-weight: 400;
      }

      .ant-menu-item {
        width: auto;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-align: center;
        align-items: center;
        height: 45px;
        padding: 0 15px !important;
      }

      .isoMenuHolder {
        display: flex;
        align-items: center;
      }

      .anticon {
        font-size: 18px;
        margin-right: 30px;
        color: inherit;
        ${transition()};
      }

      i {
        font-size: 19px;
        color: inherit;
        margin: ${(props) =>
    props["data-rtl"] === "rtl" ? "0 0 0 10px" : "0 10px 0 0"};
        width: 18px;
        ${transition()};
      }

      .nav-text {
        font-size: 14px;
        color: #999999;
        font-weight: 400;
        ${transition()};
      }

      .ant-menu-item-selected {
        background-color: rgba(0, 0, 0, 0.4) !important;
        .anticon {
          color: #fff;
        }

        i {
          color: #fff;
        }

        .nav-text {
          color: #E8572D;
        }
      }

      > li {
        &:hover {
          i,
          .nav-text {
            color: #999999;
          }
        }
      }
    }

    .ant-menu-dark .ant-menu-inline.ant-menu-sub {
      background: ${palette("secondary", 5)};
    }

    .ant-menu-submenu-inline,
    .ant-menu-submenu-vertical {
      > .ant-menu-submenu-title {
        width: 100%;
        display: flex;
        align-items: center;
        // padding: 0 !important;

        > span {
          display: flex;
          align-items: center;
        }

        &:after {
          content: "\f123";
          font-family: "Ionicons" !important;
          font-size: 16px;
          color: inherit;
          left: ${(props) => (props["data-rtl"] === "rtl" ? "16px" : "auto")};
          right: ${(props) => (props["data-rtl"] === "rtl" ? "auto" : "16px")};
          ${transition()};
        }

        &:hover {
          &:after {
            color: #ffffff;
          }
        }
      }

      .ant-menu-inline,
      .ant-menu-submenu-vertical {
        > li:not(.ant-menu-item-group) {
          padding-left: ${(props) =>
    props["data-rtl"] === "rtl" ? "0px !important" : "60px !important"};
          padding-right: ${(props) =>
    props["data-rtl"] === "rtl" ? "74px !important" : "0px !important"};
          font-size: 13px;
          font-weight: 400;
          color: inherit;
          ${transition()};

          &:hover {
            color: #ffffff;
          }
        }

        .ant-menu-item-group {
          padding-left: 0;

          .ant-menu-item-group-title {
            padding-left: 100px !important;
          }
          .ant-menu-item-group-list {
            .ant-menu-item {
              padding-left: 125px !important;
            }
          }
        }
      }

      .ant-menu-sub {
        background-color: transparent !important;
      }
    }

    &.ant-layout-sider-collapsed {
      .nav-text {
        display: none;
      }

      .ant-menu-submenu-inline > {
        .ant-menu-submenu-title:after {
          display: none;
        }
      }

      .ant-menu-submenu-vertical {
        > .ant-menu-submenu-title:after {
          display: none;
        }

        .ant-menu-sub {
          background-color: transparent !important;

          .ant-menu-item {
            height: 35px;
          }
        }
      }
    }
  }
`;

export default WithDirection(SidebarHorizontalWrapper);
